export default __webpack_public_path__ + "static/media/data-as-a-service.d31c8e3e.svg";